import { ChangeEvent } from 'react';
import { NumericFormatProps } from 'react-number-format';
import { InputProps, InputValue } from '@optimus-web/core';

export enum SymbolSpacing {
    None = 'None',
    Single = 'Single',
}

export enum SymbolPosition {
    Prefix = 'Prefix',
    Suffix = 'Suffix',
}

export interface CurrencySymbolProps {
    symbol?: string;
    symbolPosition?: SymbolPosition;
    symbolSpacing?: SymbolSpacing;
}

export interface CurrencySeparatorProps {
    decimalSeparator?: string;
    groupSeparator?: string;
}

export interface CurrencyInputProps
    extends Pick<
            NumericFormatProps<InputProps>,
            'thousandsGroupStyle' | 'fixedDecimalScale' | 'allowNegative' | 'allowLeadingZeros'
        >,
        Omit<
            InputProps,
            'onChange' | 'defaultValue' | 'prefix' | 'suffix' | 'type' | 'clearable' | 'leadingImage' | 'trailingImage'
        >,
        CurrencySymbolProps,
        CurrencySeparatorProps {
    onChange?: (event: ChangeEvent<HTMLInputElement>, value: InputValue) => void;
    max?: number;
    min?: number;
    precision?: number;
}
